import Theme from "./Theme";

export default Theme;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Theme/index.ts